import { HierarchyLevels } from '@retail/products/types';
import { CalculusArea } from './CalculusAreas';
import { bindingFromHierarchyLevel, ConditionBinding } from './CreateConditions';
import { SupplierItemBinding } from './Conditions';
import { SupplierBase } from '@retail/suppliers/types';

export interface ConditionBaseProps<T extends ItemConditionBase<T>> {
  id: number;
  assortmentId: number;
  assortmentName: string;
  supplier?: SupplierBase;
  inDraft: boolean;
  type: CalculusArea;
  bindingType: HierarchyLevels;
  bindingTarget: string;
  bindingTargetName: string;
  bindingTargetId: string;
  bindingTargetItem?: SupplierItemBinding;
  validFrom: Date;
  validTo?: Date;
}

export abstract class ItemConditionBase<T extends ItemConditionBase<T>> {
  id: number;
  assortmentId: number;
  assortmentName: string;
  supplier?: SupplierBase;
  inDraft: boolean;
  type: CalculusArea;
  bindingType: HierarchyLevels;
  bindingTarget: string;
  bindingTargetName: string;
  bindingTargetId: string;
  bindingTargetItem?: SupplierItemBinding;
  validFrom: Date;
  validTo?: Date;

  protected constructor({
    id,
    assortmentId,
    assortmentName,
    supplier,
    inDraft,
    type,
    bindingType,
    bindingTarget,
    bindingTargetName,
    bindingTargetId,
    bindingTargetItem,
    validFrom,
    validTo,
  }: ConditionBaseProps<T>) {
    this.id = id;
    this.assortmentId = assortmentId;
    this.assortmentName = assortmentName;
    this.supplier = supplier;
    this.inDraft = inDraft;
    this.type = type;
    this.bindingType = bindingType;
    this.bindingTarget = bindingTarget;
    this.bindingTargetName = bindingTargetName;
    this.bindingTargetId = bindingTargetId;
    this.bindingTargetItem = bindingTargetItem;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  getBindingLevel = (): ConditionBinding =>
    bindingFromHierarchyLevel(this.bindingType, this.bindingTargetId, this.supplier?.supplierNumber);

  getBaseProps = (): { [K in keyof ConditionBaseProps<T>]: ConditionBaseProps<T>[K] } => {
    const props: { [K in keyof ConditionBaseProps<T>]: ConditionBaseProps<T>[K] } = {
      id: this.id,
      assortmentId: this.assortmentId,
      assortmentName: this.assortmentName,
      supplier: this.supplier,
      inDraft: this.inDraft,
      type: this.type,
      bindingType: this.bindingType,
      bindingTarget: this.bindingTarget,
      bindingTargetName: this.bindingTargetName,
      bindingTargetId: this.bindingTargetId,
      bindingTargetItem: this.bindingTargetItem,
      validFrom: this.validFrom,
      validTo: this.validTo,
    };

    return props;
  };
}
